import { formatEther } from 'ethers/lib/utils'
import React, { useEffect, useState } from 'react'
import Button from './Button'
import Modal from "./Modal"
import ProgressList from './ProgressList'

export default function TransactionFlowModal({
  price,
  desiredCount,
  executeFn,
  wethAllowance,
  approveWETHFn,
  open,
  onClose
}) {
  const [hasApproval, setHasApproval] = useState(price.lte(wethAllowance))
  const [approvalError, setApprovalError] = useState(null)

  const [isSuccess, setSuccess] = useState(false)
  const [purchaseError, setPurchaseError] = useState(null)

  const [loading, setLoading] = useState(false)

  const progressItems = [
    {
      label: 'Approve WETH',
      success: hasApproval,
      errorMessage: approvalError,
    },
    {
      label: 'Buy Token',
      success: isSuccess,
      errorMessage: purchaseError
    }
  ]

  let nextLabel = "Approve"
  if (hasApproval) {
    nextLabel = `Buy for ${formatEther(price)}`
  }

  if (isSuccess || purchaseError) {
    nextLabel = 'Close'
  }

  if (loading) {
    nextLabel = 'Loading...'
  }

  async function nextStep() {
    setLoading(true)

    try {
      if (!hasApproval) {
        const result = await approveWETHFn()

        if (result.errorMessage) {
          setApprovalError(result.errorMessage)
        } else {
          setHasApproval(true)
        }
      } else if(!isSuccess && !purchaseError) {
        const result = await executeFn(desiredCount)

        if (result.errorMessage) {
          setPurchaseError(result.errorMessage)
        } else {
          setSuccess(true)
        }
      } else {
        closeModal()
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    setHasApproval(price.lte(wethAllowance))
    setPurchaseError(null)
    setApprovalError(null)
    setSuccess(false)
  }, [open])

  function closeModal() {
    onClose()
  }

  return <Modal open={open} onClose={closeModal}>
    <div className='mb-4 overflow-y-hidden'>
      <ProgressList items={progressItems}
      />
    </div>

    <div className='flex justify-end'>
      <Button onClick={nextStep} disabled={loading}>
        { nextLabel }
      </Button>
    </div>
  </Modal>
}
